import { Inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { OeeAppState } from '../../../store/oee.reducer';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  IGetTaskFolderParams,
  ITaskFolderFilterResponse,
} from '../../component/filter/task-folder-filter/task-folder-filter.model';
import { BaseOneResponseInterface } from '../../model/interface/crud-response-interface.model';

@Injectable({ providedIn: 'root' })
export class TaskFolderService {
  private readonly routes = {
    folder: `${this.baseUrl}/tree-nodes/task-folder-filter`,
  };

  constructor(
    private http: HttpClient,
    @Inject('API_BASE_URL') private readonly baseUrl: string,
    private store: Store<OeeAppState>,
  ) {}

  public getTaskFolderFilter(
    params: IGetTaskFolderParams,
  ): Observable<BaseOneResponseInterface<ITaskFolderFilterResponse>> {
    const httpParams: HttpParams = new HttpParams()
      .append('lineIds', String(params.lineIds))
      .append('activityIds', String(params.activityIds));
    return this.http.get<BaseOneResponseInterface<ITaskFolderFilterResponse>>(this.routes.folder, {
      params: httpParams,
    });
  }
}
